import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useStaffRole } from "@/hooks/useStaffRole";

/**
 * AdminRoute — auth + role guard for /admin/* routes.
 * - Not authenticated → /portal/login
 * - Staff (any role) → render children (AdminLayout handles per-page permission checks)
 */
const AdminRoute = () => {
  const { isStaff, loading } = useStaffRole();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
      </div>
    );
  }

  if (!isStaff) {
    const redirect = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/portal/login?redirect=${redirect}`} replace />;
  }

  return <Outlet />;
};

export default AdminRoute;
